import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import '@angular/localize/init';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import {
  NgbDatepickerModule,
  NgbTimepickerI18n,
  NgbTimepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { LetDirective } from '@ngrx/component';

import { AsteriskComponent } from './components/asterisk/asterisk.component';
import { DatePickerNavigationComponent } from './components/date-picker-navigation/date-picker-navigation.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { DateTimePickerComponent } from './components/datetime-picker/datetime-picker.component';
import { MonthPickerComponent } from './components/month-picker/month-picker.component';
import { PredefinedDatesPickerComponent } from './components/predefined-dates-picker/predefined-dates-picker.component';
import { AtaraxiaTimepickerI18n } from './components/time-picker.i18n';
import { WeekNumberComponent } from './components/week-number/week-number.component';
import { WeekPickerComponent } from './components/week-picker/week-picker.component';
import { WeekHighlightDirective } from './directives/week-highlight.directive';
import { DeliveryDatePipe } from './pipes/delivery-date/delivery-date.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { ToNGBDatePipe } from './pipes/to-ngb-date.pipe';
import { UtcDatePipe } from './pipes/utc-date/utc-date.pipe';
import { WeekrangeDatePipe } from './pipes/weekrange-date/weekrange-date.pipe';

/** Declared components, pipes and directives that need to be exported by the module */
const PUBIC_DECLARATIONS = [
  TimeAgoPipe,
  DeliveryDatePipe,
  DatePickerComponent,
  DateRangePickerComponent,
  WeekPickerComponent,
  WeekHighlightDirective,
  UtcDatePipe,
  DateTimePickerComponent,
  WeekrangeDatePipe,
  PredefinedDatesPickerComponent,
];

/**
 * Date utilities module
 */
@NgModule({
  declarations: [
    PUBIC_DECLARATIONS,
    ToNGBDatePipe,
    WeekNumberComponent,
    AsteriskComponent,
    MonthPickerComponent,
    DatePickerNavigationComponent,
  ],
  imports: [
    CommonModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    ReactiveFormsModule,
    IconsModule,
    LetDirective,
    TooltipDirective,
  ],
  providers: [
    DatePipe,
    ToNGBDatePipe,
    {
      provide: NgbTimepickerI18n,
      useClass: AtaraxiaTimepickerI18n,
    },
  ],
  exports: [PUBIC_DECLARATIONS],
})
export class DateModule {}
